import type { PartnerCockpitReimbursementState } from '@houzy/schemas/partner-cockpit/reimbursement';
import Button from '@mui/material/Button';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/ButtonLink';
import { reimbursementStateLabelKey, REIMBURSEMENT_STEP_PATHS, type ReimbursementOrigin } from '../../reimbursement';

export type ReimbursementButtonProps = {
    state: PartnerCockpitReimbursementState;
    offerRequestLeadUuid: string;
    origin: ReimbursementOrigin;
    reimbursedCredits?: number;
};

export function ReimbursementButton({
    state,
    offerRequestLeadUuid,
    origin,
    reimbursedCredits,
}: ReimbursementButtonProps): ReactElement {
    const { t } = useTranslation();
    const label =
        state === 'Approved' && reimbursedCredits !== undefined
            ? t('REIMBURSEMENT.BUTTON.APPROVED_WITH_CREDITS', { count: reimbursedCredits })
            : t(reimbursementStateLabelKey(state));

    if (state !== 'Requestable') {
        return (
            <Button color="inherit" disabled>
                {label}
            </Button>
        );
    }

    return (
        <ButtonLink
            to={REIMBURSEMENT_STEP_PATHS.terms}
            params={{ offerRequestLeadUuid }}
            search={{ from: origin }}
            replace
            color="inherit">
            {label}
        </ButtonLink>
    );
}
